import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Navbar, Footer } from "../components/Layout";
import { BlockRenderer } from "../components/Blocks";
import Landing from "./Landing";
import { Helmet } from "../components/Helmet";

/**
 * Homepage : si une page admin avec slug "home" existe (et est publiée),
 * on l'affiche en utilisant le système de blocs dynamiques (admin-editable).
 * Sinon on retombe sur le Landing statique historique pour ne rien casser.
 */
export default function HomePage() {
  const [page, setPage] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [testimonials, setTestimonials] = useState([]);
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/pages/home")
      .then(r => setPage(r.data))
      .catch(() => setPage(null))
      .finally(() => setLoaded(true));
    api.get("/testimonials").then(r => setTestimonials(r.data)).catch(() => {});
    api.get("/partners").then(r => setPartners(r.data)).catch(() => {});
  }, []);

  if (!loaded) return <div className="p-24 text-center font-mono text-sm">Chargement…</div>;

  // Fallback : Landing statique historique
  if (!page) return <Landing />;

  return (
    <div className="min-h-screen bg-[#F9F9F7]" data-testid="dynamic-home">
      <Helmet
        title={page.meta_title || page.title}
        description={page.meta_description}
        ogImage={page.og_image}
        path="/"
      />
      <Navbar />
      {(page.blocks || []).map((b, i) => (
        <BlockRenderer key={b._uid || `home-${i}`} block={b} testimonials={testimonials} partners={partners} />
      ))}
      <Footer />
    </div>
  );
}
